import { createSelector } from 'reselect'
import {
  dimensionsSelector,
  hasSubscriptionSelector
} from 'reduxModules/app/selectors'
import { isLoggedInSelector } from 'reduxModules/auth/selectors'
import { isLibrarySubscriberSelector } from 'reduxModules/users/selectors'

const doesTitleMatch = (state, props) => props.title === state.menuItem.open
const activeSelector = (state) => state.menuItem.open

export default createSelector(
  [doesTitleMatch, isLibrarySubscriberSelector],
  (show, isLibrarySubscriber) => ({ show, isLibrarySubscriber })
)

export const mobileMenuSelector = createSelector(
  [activeSelector, dimensionsSelector, isLoggedInSelector, hasSubscriptionSelector],
  (active, dimensions, isLoggedIn, isSubscriber) => ({
    active,
    ...dimensions,
    isLoggedIn,
    isSubscriber: Boolean(isSubscriber)
  })
)
